import {focusElement, hookToAttributeSelector} from '@wix/panda-js-utils'
import {useDidUpdate} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEffect} from 'react'
import {FormStep} from '../../../../constants'

interface UseFocusHandlerParams {
  expanded: boolean
  index: number
}

export const useFocusHandler = ({expanded, index}: UseFocusHandlerParams) => {
  useDidUpdate(() => {
    if (expanded) {
      setTimeout(() => {
        focusElement({selector: hookToAttributeSelector(DH.TICKET_DETAILS_FORM(index))})
      }, 10)
    }
  }, [expanded])

  useEffect(() => {
    focusElement({selector: hookToAttributeSelector(DH.CHECKOUT_STEP(FormStep.TicketsDetails))})
  }, [])
}
